import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';

export const useDelete = () => {
  const { invalidateQuery } = useInvalidateQueries(QueryKey.GET_STAKEHOLDERS);
  const { mutate: deleteStakeholder } = useAppMutation([QueryKey.DELETE_STAKEHOLDER], {
    mutationFn: (stakeholderId: string) =>
      ApiService.delete({
        endpoint: BackendRoute.STAKEHOLDERS,
        routePath: [stakeholderId],
      }),
    onSuccess: () => {
      invalidateQuery();
    },
  });

  return {
    deleteStakeholder,
  };
};
